import tw from 'twin.macro'

const PageHeader = tw.h1`
font-heading text-4xl font-semibold  border-b-2 border-red-800 border-solid mb-10
`

export default PageHeader
